import http from "../http-common";
import { Prototype } from "../models/prototypeModel";

class ProtoTypeDataService {
  async createProtoType(protoType: Prototype) {
    const json = JSON.stringify(protoType);
    return await http.post("/protoType/create", json);
  }

  async getProtoType(protoType: { id : string}) {
    const json = JSON.stringify(protoType);
    return await http.post("/protoType/get", json);
  }

  async getProtoTypesByProject(protoType: { projectId : string}) {
    const json = JSON.stringify(protoType);
    return await http.post("/protoType/prototypesByProject", json);
  }

  async getMetaDataByProject(protoType: { projectId : string}) {
    const json = JSON.stringify(protoType);
    return await http.post("/protoType/getMetaDataToPrototype", json);
  }
}

export default new ProtoTypeDataService();